import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual, RscFromStore } from 'helpers/utils'
import { getRscObject } from "helpers/rsc";
import { ResultRankDiff } from "components/presentation/ResultRank"
import { getIsRelay100M, getIsRelay200M, isLess4Intermediates, isPhaseFinal } from 'components/sports/swm/helper/SwmHelpers'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Esl from "components/common/Esl";

export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { config } = props;

    const { mirs_rsc } = useUrlFriendlyToParameters()
    const isRelay100m = getIsRelay100M(mirs_rsc);
    const isRelay200m = getIsRelay200M(mirs_rsc);


    let data = row?.teamAthletes?.some(val => val.hasOwnProperty('athlete'))
        ? row.teamAthletes
        : undefined

    const dataTeam = ((row?.extendedResults && row.extendedResults.length > 0))
        ? row.extendedResults
        : undefined
    data?.sort((a, b) => a.order - b.order);
    const { sex: gender } = getRscObject(RscFromStore());
    let showGender = gender === 'X';

    const eslData = row?.extCompetitor

    const isLess4 = isLess4Intermediates(mirs_rsc);
    const isFinal = isPhaseFinal(mirs_rsc);
    return (
        <>
            <Esl data={eslData} />
            <table className="table table-detail">
                <thead>
                    <tr>
                        <th className="text-end w-10">
                            {isFinal
                                ? <Label data="HeaderQualifyingTime" />
                                : <Label data="HeaderEntryTime" />
                            }
                        </th>
                        <th className="text-start "><Label data="HeaderName" /></th>
                        {showGender && <th className="text-start w-10"><Label data="HeaderGender" /></th>}
                        <th className="text-end w-10"><Label data="HeaderReaction" /></th>
                        <th className="text-end w-10"><Label data="Header50m" /></th>
                        <th className="text-end w-10"><Label data="Header100m" /></th>
                        {isRelay200m
                            ? <><th className="text-end w-10"><Label data="Header150m" /></th>
                                <th className="text-end w-10"><Label data="Header200m" /></th></>
                            : ''
                        }
                        <th className="text-end w-10"><Label data="HeaderTotalTime" /></th>
                        <th></th>

                    </tr>
                </thead>
                <tbody>

                    {data && data.map((val, key) => {

                        //let res = findArray(data, { er_pos: [val.pos] })
                        let qualTime = row?.eventUnitEntries?.find(item => item.eue_code === 'QUAL_TIME')?.eue_value;

                        let intermediate1 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['1'] })

                        let entryTime = (intermediate1?.er_pos === '1')
                            ? <> {qualTime} </>
                            : ''

                        let extR = findArray(val?.extResults, { er_type: ['ER'], er_code: ['REACT_TIME'] })

                        let intermediate2 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['2'] })
                        let intermediate3 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['3'] })
                        let intermediate4 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['4'] })
                        let intermediate5 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['5'] })
                        let intermediate6 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['6'] })
                        let intermediate7 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['7'] })
                        let intermediate8 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['8'] })
                        let intermediate8F = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['F'] })

                        let intermediate9 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['9'] })
                        let intermediate10 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['10'] })
                        let intermediate11 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['11'] })
                        let intermediate12 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['12'] })
                        let intermediate13 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['13'] })
                        let intermediate14 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['14'] })
                        let intermediate15 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['15'] })
                        let intermediate16 = findArray(val?.extResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['F'] })

                        // totaltimes
                        let interTotalTime4 = findArray(row?.extendedResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['4'] })
                        let totalTime4
                        { totalTime4 = intermediate4?.er_value2 === interTotalTime4?.er_value2 ? interTotalTime4.er_value : '' }
                        let interTotalTime6 = findArray(row?.extendedResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['6'] })
                        let totalTime6
                        { totalTime6 = intermediate6?.er_value2 === interTotalTime6?.er_value2 ? interTotalTime6.er_value : '' }
                        let interTotalTime8F = findArray(row?.extendedResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['F'] })
                        let totalTime8F
                        { totalTime8F = intermediate8F?.er_value2 === interTotalTime8F?.er_value2 ? interTotalTime8F.er_value : '' }
                        let interTotalTime8 = findArray(row?.extendedResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['8'] })
                        let totalTime8
                        { totalTime8 = intermediate8?.er_value2 === interTotalTime8?.er_value2 ? interTotalTime8.er_value : '' }
                        let interTotalTime12 = findArray(row?.extendedResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['12'] })
                        let totalTime12
                        { totalTime12 = intermediate12?.er_value2 === interTotalTime12?.er_value2 ? interTotalTime12.er_value : '' }
                        let interTotalTime16 = findArray(row?.extendedResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: ['F'] })
                        let totalTime16
                        { totalTime16 = intermediate16?.er_value2 === interTotalTime16?.er_value2 ? interTotalTime16.er_value : '' }

                        return (
                            <tr key={'expanded_' + val.athlete.code + '_' + key}>
                                <td className="text-end">{entryTime}</td>
                                <td className="text-start">{val?.athlete.name}</td>
                                {showGender && <td className="text-start">{val?.athlete?.personGender?.code}</td>}

                                <td className="text-end">{extR?.er_value}</td>

                                <td className="text-end">
                                    {isRelay100m
                                        ? <><ResultRankDiff result={intermediate1?.er_value} rank={intermediate1?.er_rank} />
                                            <ResultRankDiff result={intermediate3?.er_value} rank={intermediate3?.er_rank} />
                                            <ResultRankDiff result={intermediate5?.er_value} rank={intermediate5?.er_rank} />
                                            <ResultRankDiff result={intermediate7?.er_value} rank={intermediate7?.er_rank} />
                                        </>
                                        : isRelay200m
                                            ? <><ResultRankDiff result={intermediate1?.er_value} rank={intermediate1?.er_rank} />
                                                <ResultRankDiff result={intermediate5?.er_value} rank={intermediate5?.er_rank} />
                                                <ResultRankDiff result={intermediate9?.er_value} rank={intermediate9?.er_rank} />
                                                <ResultRankDiff result={intermediate13?.er_value} rank={intermediate13?.er_rank} />
                                            </>
                                            : ''
                                    }
                                </td>
                                <td className="text-end">
                                    {isRelay100m
                                        ? <><ResultRankDiff result={intermediate2?.er_value2} rank={intermediate2?.er_rank} />
                                            <ResultRankDiff result={intermediate4?.er_value2} rank={intermediate4?.er_rank} />
                                            <ResultRankDiff result={intermediate6?.er_value2} rank={intermediate6?.er_rank} />
                                            <ResultRankDiff result={intermediate8F?.er_value2} rank={intermediate8F?.er_rank} />
                                        </>
                                        : isRelay200m
                                            ? <><ResultRankDiff result={intermediate2?.er_value2} rank={intermediate2?.er_rank} />
                                                <ResultRankDiff result={intermediate6?.er_value2} rank={intermediate6?.er_rank} />
                                                <ResultRankDiff result={intermediate10?.er_value2} rank={intermediate10?.er_rank} />
                                                <ResultRankDiff result={intermediate14?.er_value2} rank={intermediate14?.er_rank} />
                                            </>
                                            : ''
                                    }
                                </td>
                                {isRelay100m
                                    ? <><td className="text-end">
                                        {intermediate2?.er_value}{totalTime4}{totalTime6}{totalTime8F}
                                    </td>
                                    </>
                                    : isRelay200m
                                        ? <>
                                            <td className="text-end">
                                                <ResultRankDiff result={intermediate3?.er_value2} rank={intermediate3?.er_rank} />
                                                <ResultRankDiff result={intermediate7?.er_value2} rank={intermediate7?.er_rank} />
                                                <ResultRankDiff result={intermediate11?.er_value2} rank={intermediate11?.er_rank} />
                                                <ResultRankDiff result={intermediate15?.er_value2} rank={intermediate15?.er_rank} />
                                            </td>
                                            <td className="text-end">
                                                <ResultRankDiff result={intermediate4?.er_value2} rank={intermediate4?.er_rank} />
                                                <ResultRankDiff result={intermediate8?.er_value2} rank={intermediate8?.er_rank} />
                                                <ResultRankDiff result={intermediate12?.er_value2} rank={intermediate12?.er_rank} />
                                                <ResultRankDiff result={intermediate16?.er_value2} rank={intermediate16?.er_rank} />
                                            </td>
                                            <td className="text-end">
                                                {intermediate4?.er_value}{totalTime8}{totalTime12}{totalTime16}
                                            </td>
                                        </>
                                        : ''
                                }

                                {/*
                            
                            */}
                                <td></td>
                            </tr>
                        )
                    })
                    }
                </tbody>
            </table>
        </>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row, nextProps.row)
    )
});